import React from "react"

class YearTabComponent extends React.Component {

	render() {
		return (
			<div className={"scenario-year-tab" + (this.props.current ? " active" : "")} onClick={this.props.onSelected}>
				{this.props.year}
			</div>
		)
	}

}

export default YearTabComponent



// WEBPACK FOOTER //
// ./src/component/scenarii/manager/year-tab-component.js